import produce from 'immer';
import { WALLET_SETTLEMENT_LIST_REQUEST, SETTLEMENT_LIST_APPROVAL_REQUEST } from '../../constants/wallet/settlementConstants';

const initialState = {

}

const walletSettlementReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case WALLET_SETTLEMENT_LIST_REQUEST:
      break;
    case SETTLEMENT_LIST_APPROVAL_REQUEST:
      break;
    default:
      break;
  }
});

export default walletSettlementReducer;
